var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',_vm._g(_vm._b({directives:[{name:"permission",rawName:"v-permission",value:(_vm.permission),expression:"permission"}],attrs:{"size":_vm.size,"type":_vm.btnObj.menuColor,"icon":_vm.btnObj.menuIcon}},'el-button',_vm.$attrs,false),_vm.$listeners),[_vm._v("\n  "+_vm._s(_vm.buttonText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }